import { de } from './format';
import { doses } from './doses';
export function status(v, lo, hi) {
    if (v === null)
        return { label: 'Keine Messung', bg: 'var(--status-none-bg)', fg: 'var(--status-none-fg)' };
    if (v < lo)
        return { label: 'Zu niedrig', bg: 'var(--status-low-bg)', fg: 'var(--status-low-fg)' };
    if (v > hi)
        return { label: 'Zu hoch', bg: 'var(--status-high-bg)', fg: 'var(--status-high-fg)' };
    return { label: 'Optimal', bg: 'var(--status-optimal-bg)', fg: 'var(--status-optimal-fg)' };
}
/** Empfehlungstext — Reihenfolge der Sätze ist Teil der Spezifikation. */
export function advice(ph, cl, ta, g) {
    const p = [];
    const doseActions = doses(ph, cl, g);
    const doseFor = (key) => doseActions.find(d => d.agentKey === key);
    if (ta !== null && ta < g.taMin) {
        p.push(`Alkalinität unter ${Math.round(g.taMin)} ppm, pH schwankt dadurch stark.`);
    }
    else if (ta !== null && ta > g.taMax) {
        p.push(`Alkalinität über ${Math.round(g.taMax)} ppm, pH lässt sich schwer senken.`);
    }
    if (ph === null) {
        p.push('Kein aktueller pH-Wert erfasst.');
    }
    else if (ph > g.phMax) {
        const d = doseFor('phMinus');
        p.push(d ? `pH senken: ${d.headline} hinzufügen.` : 'pH senken.');
    }
    else if (ph < g.phMin) {
        const d = doseFor('phPlus');
        p.push(d ? `pH anheben: ${d.headline} hinzufügen.` : 'pH mit pH-Plus anheben.');
    }
    if (cl === null) {
        p.push('Kein aktueller Chlorwert erfasst.');
    }
    else if (cl < g.clMin) {
        const d = doseFor('chlor');
        p.push(d ? `Chlor zu niedrig: ${d.headline} hinzufügen.` : `Chlor liegt unter ${de(g.clMin, 2)} mg/l.`);
    }
    else if (cl > g.clMax) {
        p.push(`Chlorung pausieren, bis der Wert unter ${de(g.clMax, 2)} mg/l fällt.`);
    }
    if (!p.length)
        return 'Alle Werte im Zielbereich. Nächste Messung in 2 Tagen, Filterlauf unverändert.';
    return p.join(' ');
}
